import * as React from 'react';
import Step from '@material-ui/core/Step';

const CustomStep = React.forwardRef((props, ref) => {
    return <Step {...props} ref={ref} />;
});

export { CustomStep as Step };
